import moment from 'moment';
import React, { useCallback, useMemo } from 'react';
import { isSpeeddate } from '../../../../../data/filters/schedule/isSpeeddate';
import { useUserSchedule } from '../../../../../data/hooks/schedule/useUserSchedule';
import SectionTitle from '../common/SectionTitle';
import styles from './ProgramAtTime.module.scss';
import ProgramListItem from './ProgramListItem';

function ProgramAtTime(props) {
    const { className = '', classNames = {}, style, eventId, start, end, title } = props,
        range = useMemo(() => moment.range(start, end), [start, end]),
        filter = useCallback(
            (session) => {
                if (isSpeeddate(session)) return false;

                const sessionRange = moment.range(session.start_local, session.end_local);
                return sessionRange.overlaps(range);
            },
            [range]
        ),
        atTime = useUserSchedule(eventId, { filter });

    // console.log('DBG attime', atTime);

    if (!atTime.length) return null;

    return (
        <div className={[className, styles.ProgramAtTime, 'content'].join(' ')} style={style}>
            {title ? <SectionTitle>{title}</SectionTitle> : null}
            {atTime.map((session) => (
                <ProgramListItem
                    key={session.id}
                    session={session}
                    classNames={{
                        startTime: styles.start,
                        name: classNames.programName,
                    }}
                />
            ))}
        </div>
    );
}

export default ProgramAtTime;
